// extracted by mini-css-extract-plugin
export default {"otpGroup":"opt_otpGroup__uI4pe","otpInput":"opt_otpInput__jGIwK","otpInputErr":"opt_otpInputErr__P2CaJ"};